<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">10</h2>
<p class="vers"><span>Hier ist</span> dein Schemel,
dort ruhn<br class="calibre1"/>
deine Füße, wo die Ärmsten und Niedersten,<br class="calibre1"/>
wo die Verlorenen leben.</p>
<p class="vers">Wenn ich versuche, mich dir zu neigen,<br class="calibre1"/>
kann mein Haupt nicht die Tiefe erreichen,<br class="calibre1"/>
wo deine Füße ruhen unter den Ärmsten<br class="calibre1"/>
und Niedersten, den Verlorenen.</p>
<p class="vers">Stolz kann niemals sich nähern, wo du<br class="calibre1"/>
umher gehst in den Gewändern der Demütigen<br class="calibre1"/>
unter den Ärmsten und Niedersten,<br class="calibre1"/>
den Verlorenen.</p>
<p class="vers">Mein Herz findet nie seinen Weg dorthin,<br class="calibre1"/>
wo du Freundschaft hältst mit den<br class="calibre1"/>
Freundlosen unter den Ärmsten, den Niedersten,<br class="calibre1"/>
den Verlorenen. <a id="page13" title="mabarosa/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0011.vue?510d64b3